/**
 * Smart Root Component
 *
 * Handles intelligent routing for the root URL (/)
 * - If user is NOT authenticated → Show LandingPage
 * - If user IS authenticated AND `showLandingOnce` is true (set by AuthContext
 *   on first OfficeRND auto-login of a tab session for an incomplete pending
 *   user) → Show LandingPage one time, then mark consumed in sessionStorage
 * - Otherwise authenticated users → Redirect to /dashboard
 *
 * This ensures logged-in users don't see the marketing landing page
 * and new visitors see the landing page as expected.
 */

import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LandingPage from '../landing/pages/LandingPage';
import Spinner from './Spinner';

const SmartRoot = () => {
  const { isAuthenticated, loading, showLandingOnce } = useAuth();

  useEffect(() => {
    if (showLandingOnce) {
      sessionStorage.setItem('landingShown', '1');
    }
  }, [showLandingOnce]);

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <Spinner size="lg" centered text="Loading..." />
      </div>
    );
  }

  if (isAuthenticated && !showLandingOnce) {
    return <Navigate to="/dashboard" replace />;
  }

  return <LandingPage />;
};

export default SmartRoot;
